export { default } from 'common/enums/base-action-product-status.enum';
